// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type NewWorkbookDatabasesQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type NewWorkbookDatabasesQuery = {
  __typename?: "GraphqlQuery";
  getDatabases: Array<{
    __typename?: "Database";
    id: string;
    datname?: string | null;
    permittedToCreateWorkbooks: boolean;
  }>;
};

export type NewWorkbookDatabaseDetailsQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type NewWorkbookDatabaseDetailsQuery = {
  __typename?: "GraphqlQuery";
  getDatabaseDetails: {
    __typename?: "Database";
    id: string;
    permittedToCreateWorkbooks: boolean;
  };
};

export const NewWorkbookDatabasesDocument = gql`
  query NewWorkbookDatabases($serverId: ID!) {
    getDatabases(serverId: $serverId, hidden: false) {
      id
      datname
      permittedToCreateWorkbooks
    }
  }
`;

/**
 * __useNewWorkbookDatabasesQuery__
 *
 * To run a query within a React component, call `useNewWorkbookDatabasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewWorkbookDatabasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewWorkbookDatabasesQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useNewWorkbookDatabasesQuery(
  baseOptions: Apollo.QueryHookOptions<
    NewWorkbookDatabasesQuery,
    NewWorkbookDatabasesQueryVariables
  > &
    (
      | { variables: NewWorkbookDatabasesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NewWorkbookDatabasesQuery,
    NewWorkbookDatabasesQueryVariables
  >(NewWorkbookDatabasesDocument, options);
}
export function useNewWorkbookDatabasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NewWorkbookDatabasesQuery,
    NewWorkbookDatabasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NewWorkbookDatabasesQuery,
    NewWorkbookDatabasesQueryVariables
  >(NewWorkbookDatabasesDocument, options);
}
// @ts-ignore
export function useNewWorkbookDatabasesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NewWorkbookDatabasesQuery,
    NewWorkbookDatabasesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  NewWorkbookDatabasesQuery,
  NewWorkbookDatabasesQueryVariables
>;
export function useNewWorkbookDatabasesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NewWorkbookDatabasesQuery,
        NewWorkbookDatabasesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  NewWorkbookDatabasesQuery | undefined,
  NewWorkbookDatabasesQueryVariables
>;
export function useNewWorkbookDatabasesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NewWorkbookDatabasesQuery,
        NewWorkbookDatabasesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NewWorkbookDatabasesQuery,
    NewWorkbookDatabasesQueryVariables
  >(NewWorkbookDatabasesDocument, options);
}
export type NewWorkbookDatabasesQueryHookResult = ReturnType<
  typeof useNewWorkbookDatabasesQuery
>;
export type NewWorkbookDatabasesLazyQueryHookResult = ReturnType<
  typeof useNewWorkbookDatabasesLazyQuery
>;
export type NewWorkbookDatabasesSuspenseQueryHookResult = ReturnType<
  typeof useNewWorkbookDatabasesSuspenseQuery
>;
export type NewWorkbookDatabasesQueryResult = Apollo.QueryResult<
  NewWorkbookDatabasesQuery,
  NewWorkbookDatabasesQueryVariables
>;
export const NewWorkbookDatabaseDetailsDocument = gql`
  query NewWorkbookDatabaseDetails($databaseId: ID!) {
    getDatabaseDetails(databaseId: $databaseId) {
      id
      permittedToCreateWorkbooks
    }
  }
`;

/**
 * __useNewWorkbookDatabaseDetailsQuery__
 *
 * To run a query within a React component, call `useNewWorkbookDatabaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewWorkbookDatabaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewWorkbookDatabaseDetailsQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useNewWorkbookDatabaseDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    NewWorkbookDatabaseDetailsQuery,
    NewWorkbookDatabaseDetailsQueryVariables
  > &
    (
      | { variables: NewWorkbookDatabaseDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    NewWorkbookDatabaseDetailsQuery,
    NewWorkbookDatabaseDetailsQueryVariables
  >(NewWorkbookDatabaseDetailsDocument, options);
}
export function useNewWorkbookDatabaseDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NewWorkbookDatabaseDetailsQuery,
    NewWorkbookDatabaseDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NewWorkbookDatabaseDetailsQuery,
    NewWorkbookDatabaseDetailsQueryVariables
  >(NewWorkbookDatabaseDetailsDocument, options);
}
// @ts-ignore
export function useNewWorkbookDatabaseDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NewWorkbookDatabaseDetailsQuery,
    NewWorkbookDatabaseDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  NewWorkbookDatabaseDetailsQuery,
  NewWorkbookDatabaseDetailsQueryVariables
>;
export function useNewWorkbookDatabaseDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NewWorkbookDatabaseDetailsQuery,
        NewWorkbookDatabaseDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  NewWorkbookDatabaseDetailsQuery | undefined,
  NewWorkbookDatabaseDetailsQueryVariables
>;
export function useNewWorkbookDatabaseDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NewWorkbookDatabaseDetailsQuery,
        NewWorkbookDatabaseDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    NewWorkbookDatabaseDetailsQuery,
    NewWorkbookDatabaseDetailsQueryVariables
  >(NewWorkbookDatabaseDetailsDocument, options);
}
export type NewWorkbookDatabaseDetailsQueryHookResult = ReturnType<
  typeof useNewWorkbookDatabaseDetailsQuery
>;
export type NewWorkbookDatabaseDetailsLazyQueryHookResult = ReturnType<
  typeof useNewWorkbookDatabaseDetailsLazyQuery
>;
export type NewWorkbookDatabaseDetailsSuspenseQueryHookResult = ReturnType<
  typeof useNewWorkbookDatabaseDetailsSuspenseQuery
>;
export type NewWorkbookDatabaseDetailsQueryResult = Apollo.QueryResult<
  NewWorkbookDatabaseDetailsQuery,
  NewWorkbookDatabaseDetailsQueryVariables
>;
